import React, { useState, Children } from 'react';
import { motion } from 'framer-motion';
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15,
      delayChildren: 0.3
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.8,
      ease: [0.2, 0.65, 0.3, 0.9]
    }
  }
};
export function ContactForm() {
  const [focusedField, setFocusedField] = useState<string | null>(null);
  const InputField = ({
    id,
    label,
    type = 'text',
    required = false
  }: {
    id: string;
    label: string;
    type?: string;
    required?: boolean;
  }) => <motion.div variants={itemVariants} className="text-left" data-id="element-11">
      <label htmlFor={id} className="block text-xs uppercase tracking-[0.2em] text-gold mb-3 ml-1" data-id="element-12">
        {label}
      </label>
      <input type={type} id={id} required={required} onFocus={() => setFocusedField(id)} onBlur={e => {
      if (!e.target.value) setFocusedField(null);
    }} className={`w-full rounded-2xl bg-cream/[0.06] border px-5 py-4 text-cream text-lg focus:outline-none transition-all duration-300 ${focusedField === id ? 'border-gold bg-cream/[0.1]' : 'border-cream/15 hover:border-cream/30'}`} placeholder={label} data-id="element-13" />
    </motion.div>;
  return <section id="contacto" className="w-full bg-forest py-32 md:py-48 px-6 relative overflow-hidden" data-id="element-14">
      <div className="max-w-3xl mx-auto relative z-10" data-id="element-15">
        <motion.div initial={{
        opacity: 0,
        y: 50
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 1.2,
        ease: [0.2, 0.65, 0.3, 0.9]
      }} className="text-center mb-16 md:mb-20" data-id="element-16">
          <span className="block text-xs md:text-sm tracking-[0.35em] uppercase text-gold mb-6" data-id="element-17">
            Contacto
          </span>
          <h2 className="text-5xl md:text-7xl text-cream italic mb-6" data-id="element-18">
            Hablemos
          </h2>
          <p className="text-base md:text-lg text-cream/70 font-light max-w-md mx-auto" data-id="element-19">
            Déjanos tus datos y nos pondremos en contacto contigo para crear
            algo extraordinario.
          </p>
        </motion.div>

        {/* Form framed with a thin gold hairline */}
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 1,
        delay: 0.2,
        ease: [0.2, 0.65, 0.3, 0.9]
      }} className="rounded-3xl border border-gold/25 bg-forest/40 backdrop-blur-sm p-8 md:p-14" data-id="element-20">
          <motion.form variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
          once: true,
          amount: 0.2
        }} className="space-y-10" onSubmit={e => e.preventDefault()} data-id="element-21">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-10" data-id="element-22">
              <InputField id="nombre" label="Nombre" required data-id="element-23" />
              <InputField id="apellido" label="Apellido" required data-id="element-24" />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-10" data-id="element-25">
              <InputField id="correo" label="Correo electrónico" type="email" required data-id="element-26" />
              <InputField id="telefono" label="Teléfono" type="tel" data-id="element-27" />
            </div>

            <motion.div variants={itemVariants} className="pt-10 text-center" data-id="element-28">
              <motion.button type="submit" whileHover={{
              scale: 1.02
            }} whileTap={{
              scale: 0.98
            }} className="bg-goldBright hover:bg-goldBrightDark text-white font-bold rounded-full px-14 py-4 uppercase tracking-[0.2em] text-sm transition-colors duration-300 shadow-md hover:shadow-lg [text-shadow:0_1px_2px_rgba(0,0,0,0.35)]" data-id="element-29">
                Enviar Mensaje
              </motion.button>
            </motion.div>
          </motion.form>
        </motion.div>
      </div>
    </section>;
}